import { render, staticRenderFns } from "./FulfillmentOptionsFooterPickup.vue?vue&type=template&id=2936f848"
import script from "./FulfillmentOptionsFooterPickup.vue?vue&type=script&lang=ts"
export * from "./FulfillmentOptionsFooterPickup.vue?vue&type=script&lang=ts"
import style0 from "./FulfillmentOptionsFooterPickup.vue?vue&type=style&index=0&id=2936f848&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports